import type { FaireProductEntity } from "../../entity_types/product";

export const p_9r88u99ph7: FaireProductEntity = {
  token: "p_9r88u99ph7",
  type: "product",
  name: "Star & Moon & Sun& Heart charm 18K Golden Bracelet - FGS/MS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/96dcf6ee6935df527957bb7ed0bd270cb5b7cc42c005f3bf0a3b9735dc37ec0c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a3309f0954d4ac5a12ad2bc704b8c3347233c3435e39f58e8978ea8cae57a713.jpeg",
    "https://cdn.faire.com/fastly/444521f51fd4edd452f081011be8c3514b906015181cbc4a9be8e791a3e0950b.jpeg",
    "https://cdn.faire.com/fastly/c8e6adb5352388d73da8981fad94bde15c557762a55465a86160200e2dbc43f7.jpeg",
  ],
  priceDollars: 9.05,
  description:
    "Type: bracelet\nMaterial: 316L Stainless steel，Cubic zirconia，18K gold plated\nLength of chain ： 160mm + 40mm\nProcess: vacuum electroplating and manual polishing，Non - tarnish\nSurface : High Polish \n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 22.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:09.142Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
